// extracted by mini-css-extract-plugin
module.exports = {"ratingStar01":"ratingStar_ratingStar01__2WYZj","active":"ratingStar_active__2TGRL","num":"ratingStar_num__22y9Q","ratingStar02":"ratingStar_ratingStar02__3R_L1"};